// The promotion email's frozen copy (ContentIQ Phase B round 3) — subject,
// preview text, body and button label, as the build team must use them.
// Shown on the PM's page card and on the build team's card for the same
// EDM build, so both sides read the same thing. Purely presentational.
//
// Props: edm {subject, preview_text, body, button_label} (from the build's
// frozen spec.edm).
import React from 'react';
import { FONTS, INK, NEUTRAL, RADII } from '../utils/wizardTheme';

// The email's fields — [key, label, rows] — shared with the PM's EDM copy
// form (DeploymentPanel.js), so both sides name them the same.
export const EDM_FIELDS = [
  ['subject', 'Subject line', 1],
  ['preview_text', 'Preview text', 1],
  ['body', 'Body', 5],
  ['button_label', 'Button label', 1],
];
const ROWS = EDM_FIELDS;

export default function CiqEdmCopy({ edm }) {
  const e = edm || {};
  const filled = ROWS.filter(([k]) => (e[k] || '').trim());
  if (!filled.length) {
    return (
      <div style={{ fontSize: '12px', color: INK.secondary }}>
        No email copy was written for this version — ask DemandArc before building.
      </div>
    );
  }
  return (
    <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: '5px 12px',
      fontSize: '12.5px', background: NEUTRAL.band, border: `1px solid ${NEUTRAL.borderSoft}`,
      borderRadius: RADII.small, padding: '10px 12px' }}>
      {filled.map(([k, label]) => (
        <React.Fragment key={k}>
          <dt style={{ color: INK.secondary, fontWeight: 600 }}>{label}</dt>
          <dd style={{ margin: 0, color: INK.primary, fontFamily: FONTS.body, whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
            {e[k]}
          </dd>
        </React.Fragment>
      ))}
    </dl>
  );
}
